/** Smooth-scroll to an element by id (no-op if the element is missing). */
export function scrollToId(id: string): void {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
